import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infraction-manager',
  templateUrl: './infraction-manager.component.html',
  styleUrls: ['./infraction-manager.component.css']
})
export class InfractionManagerComponent implements OnInit {
  show0 = true;
  show1 = true;
  show2 = true;
  constructor() { }

  ngOnInit(): void {
  }

  toggle(id : number) {
    switch(id) {
      case 0: {
        this.show0 = !this.show0;
        break;
      }
      case 1: {
        this.show1 = !this.show1;
        break;
      }
      case 2: {
        this.show2= !this.show2;
        break;
      }
    }
  }
}
